
let swiper;
window.addEventListener("load", function() {
    swiper = new Swiper('.main-swiper', {
        direction: "vertical",
        slidesPerView: 1,
        effect: 'fade',
        preloadImages: false,
        mousewheel: true,
        allowTouchMove: false,
        lazy: {
            loadPrevNext: false,
            loadOnTransitionStart: false,
        },
        on: {
            slideChange() {
                // const $nav = $('#kto-tet-navigation');
                // if (!$nav.length) return;
                // if ($('body').data('device-type') === 'desktop') {
                //   if (this.activeIndex > 0) $nav.hide(); else $nav.show();
                // }
            }
        }
    });

    // Export to window for global access
    window.swiper = swiper;

    const $nav = $('#kto-tet-navigation');
    if ($nav.length) $nav.toggle(swiper.activeIndex === 0);
});

let allowScrollTrigger = true;
let touchStartY = 0;

window.addEventListener('touchstart', function(e) {
    touchStartY = e.touches[0].clientY;
});

window.addEventListener('touchend', function(e) {
    const touchEndY = e.changedTouches[0].clientY;
    const deltaY = touchStartY - touchEndY;

    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const docHeight = document.documentElement.scrollHeight;

    // Vuốt lên → nếu gần cuối trang thì slideNext
    if (deltaY > 30 && Math.abs(docHeight - (scrollTop + windowHeight)) < 5) {
        swiper.slideNext();
    }

    // Vuốt xuống → nếu gần đầu trang thì slidePrev
    else if (deltaY < -30 && scrollTop < 5) {
        swiper.slidePrev();
    }
});